import React, { useContext } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { contextApiActions } from "../../../_redux/_constants";
import { Context } from "../../../_context/Store";

function UiLargeModal(props) {
     const { open, heading, children, icon } = props;

     const [state, dispatch] = useContext(Context);

     const handleClose = () => {
          dispatch({
               type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
               payload: { show: false },
          });
     };

     const style = {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 950,
          bgcolor: "background.paper",
          border: "none",
          boxShadow: 0,
          p: 4,
          outline: "none",
     };

     return (
          <>
               <Modal
                    open={state.uiLargeModalDetails.show}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
               >
                    <Box sx={style}>
                         <div className="sba-modal-close">
                              <IconButton onClick={handleClose}>
                                   <CloseIcon />
                              </IconButton>
                         </div>
                         <Typography
                              id="modal-modal-title"
                              variant="h5"
                              component="h1"
                              sx={{ mb: 0.6 }}
                              className="sba-modal-heading"
                         >      
                              {state.uiLargeModalDetails.heading}
                         </Typography>
                         {state.uiLargeModalDetails.children}
                    </Box>
               </Modal>
          </>
     );
}

export default UiLargeModal;
